export default "__VITE_ASSET__DgcjNJiy__"